'use client';
import { ReactNode } from 'react';
import { useNavigation } from './NavigationContext';
import classNames from '@wilkins-software/classnames-tailwind-merge';

export function Nav({
  children,
  isSlate,
  isFixed = true,
}: {
  children: ReactNode;
  isSlate?: boolean;
  isFixed?: boolean;
}) {
  const { isMenuOpen, pathname } = useNavigation();

  const isBgWhite = !isSlate || isMenuOpen;

  return (
    <nav
      data-pathname={pathname}
      data-menu-open={isMenuOpen ? 'true' : 'false'}
      className={classNames(
        'navbar w-full transition-colors duration-300 ease-[cubic-bezier(0.16,1,0.3,1)]',
        {
          'bg-slate-50': isSlate && !isMenuOpen,
          // Avoid backdrop-filter here: it creates a containing block that
          // breaks position:fixed descendants. Mobile menu is portaled instead.
          'bg-white max-lg:border-b max-lg:border-black/5':
            isBgWhite || isMenuOpen,
          // h-16 keeps the bar flush with ArticleReadingProgress (`top-16`)
          // and main `pt-16` — mobile content alone is shorter (~60px) and left a gap.
          'fixed top-0 z-[60] h-16': isFixed,
        },
      )}
      id="navbar"
    >
      {children}
    </nav>
  );
}
